export default {
  subTitle: 'A SMS with the code was sent to the phone number {{phone}} ',
  authenticationApp: 'Authentication App',
  SMSCode: 'SMS Code',
  resendCode: 'Resend Code',
  timeLeft: '{{minutes}}:{{seconds}}',
};
